import { Component, Input, OnInit } from '@angular/core';
import { NutritionTable } from '../../model/nutrition-table';

@Component({
    selector: 'pme-window-shop-manager-nutrition-table',
    templateUrl: './window-shop-manager-nutrition-table.component.html',
    styleUrls: ['./window-shop-manager-nutrition-table.component.scss'],
    standalone: false
})
export class WindowShopManagerNutritionTableComponent implements OnInit {

  @Input() tableNutritionContent: NutritionTable;

  constructor() { }

  ngOnInit(): void {
  }

}
